export const responsesTable = [
    {
        column: 'Nome',
    },
    {
        column: 'Email',
    },
    {
        column: 'Formulário',
    },
    {
        column: 'Status',
    },
    {
        column: 'Feedback',
    },
    {
        column: 'Data',
    },
    {
        column: 'Ações',
    },
];

export const responsesKeys = ['name', 'email', 'form_title', 'status', 'has_feedback', 'created_at', 'actions'];
